// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_TAG_MODAL_CHANGE,
} from './constants';

export function tagModalChange({visible}) {
  return {
    type: SYSTEM_TAG_MODAL_CHANGE,
     data: {visible},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_TAG_MODAL_CHANGE:
      return {
        ...state,
        tagModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/tagModalChange.js